import RemoveIcon from '@mui/icons-material/Remove';
import { Checkbox as MuiCheckbox, FormControlLabel, Grid, IconButton, Popover } from '@mui/material';
import Box from '@mui/material/Box';
import { useFormikContext } from 'formik';
import * as React from 'react';
import { memo, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { ResourceType } from '../../../../../backend';
import { StyledFormGroup } from '../../../../form/Checkbox/Checkbox.style';
import { ResourcesPageFormValues } from '../../../../pages/ResourcesPage';
import { MultiResourcesForm } from './MultiResourcesForm';
import { StyledMenuIcon, StyledPropertiesGrid } from './PropertiesMenu.style';
import { getPropertiesListByType } from './PropertiesMenu.utils';

export const PropertiesMenu = memo(function PropertiesMenu({
    resourceType,
    selectedResources,
    setSelectedResources,
    arrayRemove,
}: {
    resourceType: ResourceType;
    selectedResources: number[];
    setSelectedResources: (e: number[]) => void;
    arrayRemove: (index: number) => void;
}) {
    const { values } = useFormikContext<ResourcesPageFormValues>();

    const handleChange = useCallback(
        event => {
            if (event.target.checked) {
                setSelectedResources(values.resources.map(r => values.resources.indexOf(r)));
            } else {
                setSelectedResources([]);
            }
        },
        [setSelectedResources, values.resources],
    );

    const [anchorEl, setAnchorEl] = React.useState<HTMLLabelElement | null>(null);

    const handleClick = (event: React.MouseEvent<HTMLLabelElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <StyledPropertiesGrid container>
            <Grid item width={'40px'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <StyledFormGroup>
                    <FormControlLabel
                        control={<MuiCheckbox icon={<span />} checkedIcon={<RemoveIcon />} />}
                        label={''}
                        checked={selectedResources.length !== 0}
                        onChange={handleChange}
                    />
                </StyledFormGroup>
            </Grid>
            {getPropertiesListByType(resourceType).map((property, index) => (
                <Grid
                    item
                    key={index}
                    color={'white'}
                    xs
                    display={'flex'}
                    justifyContent={'center'}
                    alignItems={'center'}
                >
                    <Box sx={{ textAlign: 'center' }}>
                        <FormattedMessage id={`Resource.${property}`} />
                    </Box>
                </Grid>
            ))}
            <Grid item width={'52px'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                <IconButton
                    aria-describedby={id}
                    aria-label="delete"
                    component="label"
                    onClick={handleClick}
                    disabled={selectedResources.length === 0}
                >
                    <StyledMenuIcon />
                </IconButton>
                <Popover
                    id={id}
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                >
                    <MultiResourcesForm
                        selectedResources={selectedResources}
                        setSelectedResources={setSelectedResources}
                        arrayRemove={arrayRemove}
                        setAnchorEl={setAnchorEl}
                        resourceType={resourceType}
                    />
                </Popover>
            </Grid>
        </StyledPropertiesGrid>
    );
});
